<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1.<span class="space1">How the Liberty Boys Shouted</span></a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2.<span class="space1">Factory to Field</span></span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3.<span class="space1">Bread Bullets Will Win the War</span></span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4.<span class="space1">With Enthusiasm, Intelligence and Ability</span></span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5.<span class="space1">The War and the School</span></span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6.<span class="space1">Columbia Is a Jealous Mother</span></span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7.<span class="space1">The Search for Great War Memory</span></span></p>
<p class="toc1"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e311b7da